<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="interface"
      :id="id"
      :page="page"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ConsumerUnitPage from './ConsumerUnitPage'

const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'ConsumerUnit',
  components: { CrudLayout },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ConsumerUnit extends Vue {
  get page () {
    return ConsumerUnitPage
  }
}

export default ConsumerUnit
</script>
<style lang="stylus" scoped></style>
